<div class="container-fluid px-4 px-md-8 bg-gray-light border-bottom border-top">
    <div class="row">
        <div class="col-12 col-lg-8 order-2 order-md-1">
            <ui-headline
                [backLinkPaths]="[routeEntity.Root, routeEntity.Programs]"
                [title]="b2bProgram?.prgName"
                [menuItems]="menuItems$ | async"
                [headlineButtonContext]="headlineButtonContext"
                [content]="contentBtn" />
        </div>
    </div>
</div>

<router-outlet (activate)="onActivate({ component: $event })"></router-outlet>
